export default __webpack_public_path__ + "static/star-c6880a9e04d097ee3ff50aa202693617.png";